import { CreditCard, Plus, Server, Smartphone } from "lucide-react"
import React from "react"
import { Link } from "react-router-dom"
import Layout from "../components/Layout"
import { Card } from "../components/ui"

interface QuickAction {
    to: string
    label: string
    description: string
    cta: string
    icon: React.ReactNode
}

const actions: QuickAction[] = [
    {
        to: "/devices",
        label: "Dispositivos",
        description: "Visualize e gerencie dispositivos cadastrados.",
        cta: "Ver dispositivos",
        icon: <Smartphone className="h-5 w-5" />,
    },
    {
        to: "/servers",
        label: "Servidores",
        description: "Ativações ilimitadas por DNS. Em desenvolvimento.",
        cta: "Saiba como vai funcionar",
        icon: <Server className="h-5 w-5" />,
    },
    {
        to: "/devices?add=1",
        label: "Adicionar dispositivo",
        description: "Vincule o código lido na TV a um link de playlist.",
        cta: "Adicionar",
        icon: <Plus className="h-5 w-5" />,
    },
    {
        to: "/payments",
        label: "Pagamentos",
        description: "Gere PIX e valide ativações de dispositivos.",
        cta: "Abrir pagamentos",
        icon: <CreditCard className="h-5 w-5" />,
    },
]

const Dashboard: React.FC = () => {
    return (
        <Layout title="Dashboard">
            <div className="flex flex-col gap-6">
                <Card>
                    <h3 className="text-lg font-semibold text-text">
                        Bem-vindo ao Nanoplay Admin
                    </h3>
                    <p className="mt-1 max-w-2xl text-sm text-muted">
                        Painel de administração da plataforma Nanoplay. Gerencie
                        códigos de acesso, dispositivos e servidores.
                    </p>
                </Card>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    {actions.map((action) => (
                        <Card
                            key={action.to}
                            className="flex flex-col justify-between gap-5"
                        >
                            <div className="flex items-start gap-4">
                                <span className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-primary/15 text-primary">
                                    {action.icon}
                                </span>
                                <div className="min-w-0">
                                    <h4 className="text-sm font-semibold text-text">
                                        {action.label}
                                    </h4>
                                    <p className="mt-1 text-sm text-muted">
                                        {action.description}
                                    </p>
                                </div>
                            </div>
                            <Link
                                to={action.to}
                                className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-fg transition-colors hover:bg-primary/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 focus-visible:ring-offset-2 focus-visible:ring-offset-bg"
                            >
                                {action.cta}
                            </Link>
                        </Card>
                    ))}
                </div>
            </div>
        </Layout>
    )
}

export default Dashboard
